// extracted by mini-css-extract-plugin
module.exports = {"imageAndLinkTitle":"style_imageAndLinkTitle__lX6Gn","videoPlayer":"style_videoPlayer__ktnhn"};